import c from "../../utils/constants";
import moment from "moment";
import env from "../../utils/env";

class ProfilesController {
  constructor(ProfilesService, FilterService, AppContextService, AuthService, $scope) {
    "ngInject"

    this.profilesService = ProfilesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.appContextService = AppContextService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
    this.imageBaseUrl = env.getStorageUrl() + "images/";

    this.onFlagChanged = (dataItem) => {
      const appContext = this.appContextService.getAppContext();
      dataItem.reviewedBy = appContext.userName;
      dataItem.dirty = true;
    }
  }

  $onInit() {
    this.profileReviewStatusOptions = {
      dataSource: [
        { value: 2, text: "In Progress" },
        { value: 0, text: "Approved" },
      ],
      dataTextField: "text",
      dataValueField: "value"
    }
  }

  getGridOptions() {

    return {
      dataSource: this.profilesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        {
          field: "fullName", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "4rem",
          template: (dataItem) => `<a class="cell" target="_blank" href="/users/${dataItem.userId}"><div class="image-container"><img src="${dataItem.imageUrl ? this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png"}"></img></div><span>${dataItem.fullName}</span></a>`,
        },
        { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" },
        // { field: "creationDate", title: "Signup Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "8rem" },
        { field: "requiredReviewsText", title: "Required Reviews", filterable: false, width: "12rem" },
        { field: "flaggedForReview", title: "Status", filterable: false, sortable: true, width: "2rem", template: (dataItem) => `${this._getProfileReviewStatus(dataItem.flaggedForReview)}` },
        // { field: "country", title: "Country", filterable: false, width: "6rem" },
        { field: "reviewedBy", title: "Reviewed By", filterable: false, width: "2rem" },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "2rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update Review Status" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.usersMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getProfileReviewStatus(status) {

    switch (status) {
      case c.profileReviewStatus.REQUIRED:
        return "Required";
      case c.profileReviewStatus.IN_PROGRESS:
        return "In Progress";
      default:
      case c.profileReviewStatus.APPROVED:
        return "Approved";
    }
  }

}

export default ProfilesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/profiles/profiles.controller.js
 **/